module.exports = __webpack_public_path__ + "static/media/icon-loading.cab04298.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-loading.svg
// module id = 42
// module chunks = 0